import { track } from '@fff-web/fff-analytics';
import getSwapAmountByPlanCode from '../../../../utils/getSwapAmountByPlanCode';
import {
  CANCEL_SUBSCRIPTION_LABEL,
  MY_ACCOUNT_EXPERIENCE,
  REACTIVATE_MEMBERSHIP_LABEL,
  TRACK_NAME_LABEL,
} from '../../../constants';
import { labelBySubscription } from '../../utils/labelBySubscription';

const CLICK_FOR_SWAP_EVENT_NAME = 'Swap Started';
const CLICK_FOR_SWAP_CTA_NAME = 'Swap for credit';

const CLICK_FOR_REACTIVATION_CTA_NAME = 'Reactivation Started';

const trackClickSwapForCredit = (userInfo) => {
  const properties = {
    swap_amount: getSwapAmountByPlanCode(userInfo.planCode),
    cta_name: CLICK_FOR_SWAP_CTA_NAME,
    experience: MY_ACCOUNT_EXPERIENCE,
  };
  track({ trackName: CLICK_FOR_SWAP_EVENT_NAME, properties }).finally(() => true);
};

const trackClickCancelSubscription = (
  user,
  ctaName = CANCEL_SUBSCRIPTION_LABEL,
  eventName = TRACK_NAME_LABEL,
  cancelType
) => {
  const properties = {
    cta_name: ctaName,
    experience: MY_ACCOUNT_EXPERIENCE,
    cancel_type: cancelType || labelBySubscription(user?.planCode),
  };
  track({ trackName: eventName, properties }).finally(() => true);
};

const trackClickReactivateMembership = () => {
  const properties = {
    cta_name: REACTIVATE_MEMBERSHIP_LABEL,
    type: 'Expired Member',
    experience: MY_ACCOUNT_EXPERIENCE,
    reactivation_type: 'Expired',
  };
  track({ trackName: CLICK_FOR_REACTIVATION_CTA_NAME, properties }).finally(() => true);
};

export { trackClickSwapForCredit, trackClickCancelSubscription, trackClickReactivateMembership };
